import _TREE from '../consts/tree.json'
import images from '../images'
import { Tree } from '../types'

export const TREE = _TREE as Tree

interface Meta {
  title: string
  logo: any
  url?: string
  introURL: string
  features: string[]
}

export const EXCHANGE_META: { [key: string]: Meta } = {
  DMMB: {
    title: 'DMM Bitcoin',
    logo: images.exchanges.DMMB,
    url: 'https://p-salm.jp/ad/p/r?_site=70&_article=24&_link=42&_image=42',
    introURL: 'https://www.coinjinja.com/blog/posts/2019/8/exchange_dmmbitcoin',
    features: [
      '【充実】レバレッジ取引の取り扱い銘柄数1位',
      '【高性能】上級者も納得！ 高機能な取引ツール',
      '【便利】豊富なトレードサービス',
    ],
  },
  GMOC: {
    title: 'GMOコイン',
    logo: images.exchanges.GMOC,
    url: 'https://www.tcs-asp.net/alink?AC=C100190&LC=GMOZ1&SQ=0&isq=100',
    introURL: 'https://www.coinjinja.com/blog/posts/2019/8/exchange_gmocoin',
    features: [
      '【高性能】取引用アプリ「ビットレ君」が優秀！',
      '【便利】アルトコインの空売りが可能',
      '【安心】セキュリティが堅牢',
    ],
  },
  CCJP: {
    title: 'Coincheck',
    logo: images.exchanges.CCJP,
    url:
      'https://www.tcs-asp.net/alink?AC=C100190&LC=COINC1&SQ=0&isq=100&uk=shindan',
    introURL: 'https://www.coinjinja.com/blog/posts/2019/8/exchange_coincheck',
    features: [
      '【充実】取り扱い銘柄の種類が豊富',
      '【簡単】初心者に分かり易いデザイン',
      '【安心】親会社は東証一部上場の金融グループ',
    ],
  },
  BTBK: {
    title: 'bitbank',
    logo: images.exchanges.BTBK,
    url: 'http://p-salm.jp/ad/p/r?_site=70&_article=3',
    introURL: 'https://www.coinjinja.com/blog/posts/2019/8/exchange_bitbank',
    features: [
      '【お得】取引すればするほどおトク!',
      '【安心】セキュリティーが堅牢',
      '【便利】アプリが使いやすく、UIが洗練されている',
    ],
  },
  QUON: {
    title: 'Liquid',
    logo: images.exchanges.QUON,
    url: 'http://p-salm.jp/ad/p/r?_site=70&_article=5',
    introURL: 'https://www.coinjinja.com/blog/posts/2019/8/exchange_liquid',
    features: [
      '【便利】 流動性が高いため、注文が通りやすい！',
      '【安心】運営資金が豊富で何かあっても安心',
      '【信頼】国内最高レベルのセキュリティー体制',
    ],
  },
  DCRT: {
    title: 'DeCurret',
    logo: images.exchanges.DCRT,
    introURL: 'https://www.coinjinja.com/blog/posts/2019/8/exchange_decurret',
    features: [
      '【安心】セキュリティと操作性の両立',
      '【便利】 24時間・即時送金に対応',
      '【信頼】 国内最大の資本力',
    ],
  },
  BTFL: {
    title: 'bitFlyer',
    logo: images.exchanges.BTFL,
    url: 'https://bitflyer.com/ja-jp/account-create',
    introURL: 'https://www.coinjinja.com/blog/posts/2019/9/exchange_bitflyer',
    features: [
      '【便利】初心者でも使いやすい',
      '【信頼】信頼性の高いバックグラウンド',
      '【お得】ビットコインをタダで入手できる',
    ],
  },
}

export const EXCHAGES_INTRO_URL =
  'https://www.coinjinja.com/blog/posts/2019/8/exchangeranking'
